<!--
    @Author : Luo
    @Time   : 2020/8/8 10:22
-->
<template>
  <div>
    <!-- 路由 -->
    <router-view />
  </div>
</template>

<script>
import '@/components/common/common_style.css'

export default {
  name: 'userMain'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page-user/index.vue